import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 19h12v2H6v-2z"
}), 'MinimizeOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MinimizeOutlined.js
// module id = 4842
// module chunks = 2